import retractableTrayImg from "@/assets/accessories/retractable-tray-baffle.png";
import fixedCupHolderImg from "@/assets/accessories/fixed-cup-holder.png";
import carpetVacuumingImg from "@/assets/accessories/carpet-vacuuming.png";
import chargingStationCC1Img from "@/assets/accessories/charging-station-cc1.png";
import selfCleaningDockingImg from "@/assets/accessories/self-cleaning-docking.png";
import mobileWaterStationImg from "@/assets/accessories/mobile-water-station.png";
import liftingRackImg from "@/assets/accessories/lifting-rack.png";
import elevatorControlImg from "@/assets/accessories/elevator-control.png";
import watch4gImg from "@/assets/accessories/4g-watch.png";
import puduPagerImg from "@/assets/accessories/pudu-pager.png";
import telephoneSystemImg from "@/assets/accessories/telephone-system.png";
import turnstilesControlImg from "@/assets/accessories/turnstiles-control.png";
import chargingStationImg from "@/assets/accessories/charging-station.png";
import traySetsImg from "@/assets/accessories/tray-sets.png";

const placeholder = "/placeholder.svg";

export type AccessoryProduct = {
  id: string;
  name: string;
  price: number;
  description?: string;
  compatibleWith?: string;
  image: string;
};

export type AccessoryGroup = {
  category: string;
  description?: string;
  products: AccessoryProduct[];
};

export const accessoryGroups: AccessoryGroup[] = [
  {
    category: "CC1 / CC1 Pro",
    description: "Accessories for the PUDU CC1 and CC1 Pro commercial cleaning robots.",
    products: [
      { id: "cc1-docking-self-cleaning", name: "CC1 Docking Station (Self-Cleaning)", price: 2293.67, image: selfCleaningDockingImg, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-charging-station", name: "CC1 Charging Station", price: 1858.48, image: chargingStationCC1Img, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-mobile-water-tank-black", name: "Mobile Water Tank — Black", price: 1940.80, image: mobileWaterStationImg, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-mobile-water-tank-gray", name: "Mobile Water Tank — Gray", price: 1940.80, image: mobileWaterStationImg, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-carpet-vacuum", name: "Carpet Vacuuming Assembly", price: 206.86, image: carpetVacuumingImg, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-expandable-waste", name: "Expandable Waste Container", price: 306.23, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-spray-gun", name: "Spray Gun Components", price: 42.59, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-suction-hose", name: "External Suction Hose Kit", price: 99.37, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-flashing-light-green", name: "Flashing Light Retrofit Kit (Green)", price: 131.82, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-flashing-light-black", name: "Flashing Light Retrofit Kit (Black/Grey)", price: 131.82, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-security-cam-green", name: "Security Camera Retrofit Kit (Green)", price: 105.46, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-security-cam-black", name: "Security Camera Retrofit Kit (Black/Grey)", price: 105.46, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-elevator-h9-usa", name: "Elevator Control System H9 — USA Standard", price: 1452.05, image: elevatorControlImg, compatibleWith: "CC1, CC1 Pro" },
      { id: "cc1-lora-na", name: "Lora Module (North America)", price: 85.18, image: placeholder, compatibleWith: "CC1, CC1 Pro" },
    ],
  },
  {
    category: "MT1 / MT1 Vac / MT1 Max",
    description: "Accessories for the PUDU MT1 series of cleaning robots.",
    products: [
      { id: "mt1-charging-station", name: "PUDU MT1 Charging Station", price: 1858.48, image: chargingStationImg, compatibleWith: "MT1, MT1 Vac, MT1 Max" },
    ],
  },
  {
    category: "BellaBot Pro",
    description: "Accessories for the BellaBot Pro delivery robot.",
    products: [
      { id: "bellabot-dish-cabinet", name: "BellaBot Dish Cabinet", price: 2040.17, image: placeholder, compatibleWith: "BellaBot Pro" },
      { id: "bellabot-large-bearing-tray", name: "Large Bearing Bottom Tray", price: 318.40, image: traySetsImg, compatibleWith: "BellaBot Pro" },
      { id: "bellabot-tray-cup-holder", name: "Bella Tray Cup Holder", price: 137.90, image: fixedCupHolderImg, compatibleWith: "BellaBot Pro" },
    ],
  },
  {
    category: "KettyBot Pro",
    description: "Accessories for the KettyBot Pro delivery & host robot.",
    products: [
      { id: "ketty-food-cover-box", name: "Food Cover Box", price: 829.45, image: placeholder, compatibleWith: "KettyBot Pro" },
      { id: "ketty-overhead-display", name: "Overhead Display Box", price: 176.44, image: placeholder, compatibleWith: "KettyBot Pro" },
      { id: "ketty-retractable-tray", name: "Retractable Tray Border", price: 85.18, image: retractableTrayImg, compatibleWith: "KettyBot Pro" },
      { id: "ketty-fixed-cup-holder", name: "Fixed Cup Holder", price: 162.24, image: fixedCupHolderImg, compatibleWith: "KettyBot Pro" },
      { id: "ketty-rear-housing-black", name: "KettyBot Pro Rear Housing Unit — Black", price: 139.93, image: placeholder, compatibleWith: "KettyBot Pro" },
    ],
  },
  {
    category: "PuduBot 2",
    description: "Accessories for the PuduBot 2 delivery robot.",
    products: [
      { id: "pudubot2-ad-screen", name: "Advertising Screen", price: 1926.60, image: placeholder, compatibleWith: "PuduBot 2" },
      { id: "pudubot2-dish-cabinet", name: "PuduBot 2 Dish Cabinet", price: 1084.98, image: placeholder, compatibleWith: "PuduBot 2" },
      { id: "pudubot2-marker-camera", name: "External Marker Camera", price: 326.51, image: placeholder, compatibleWith: "PuduBot 2" },
      { id: "pudubot2-ad-screen-kit", name: "Advertising Screen Installation Kit", price: 298.12, image: placeholder, compatibleWith: "PuduBot 2" },
      { id: "pudubot2-tray-cup", name: "Tray Cup Holder", price: 158.18, image: fixedCupHolderImg, compatibleWith: "PuduBot 2" },
    ],
  },
  {
    category: "BellaBot / KettyBot / PuduBot 2",
    description: "Shared accessories for delivery robots.",
    products: [
      { id: "pudu-charging-pile-ws1-usa", name: "Pudu Charging Pile WS1 — USA", price: 1235.88, image: chargingStationImg, compatibleWith: "BellaBot, KettyBot, PuduBot 2" },
    ],
  },
  {
    category: "Multi-Robot",
    description: "Universal accessories compatible with multiple robot models.",
    products: [
      { id: "pudu-watch", name: "Pudu Watch (Staff Pager)", price: 255.53, image: watch4gImg, compatibleWith: "All PUDU Robots" },
      { id: "pudu-pager-single", name: "Pudu Pager (Single)", price: 79.09, image: puduPagerImg, compatibleWith: "All PUDU Robots" },
      { id: "pager-combo-6", name: "Pager Combo Pack — 6 pcs", price: 888.26, image: puduPagerImg, compatibleWith: "All PUDU Robots" },
      { id: "pager-combo-12", name: "Pager Combo Pack — 12 pcs (Large)", price: 1028.20, image: puduPagerImg, compatibleWith: "All PUDU Robots" },
      { id: "lora-universal", name: "LORA Module (Universal)", price: 40.56, image: placeholder, compatibleWith: "All PUDU Robots" },
      { id: "turnstile-door-control", name: "Turnstile / Automatic Door Control", price: 225.11, image: turnstilesControlImg, compatibleWith: "All PUDU Robots" },
    ],
  },
  {
    category: "FlashBot Max",
    description: "Accessories for the FlashBot Max service robot.",
    products: [
      { id: "flashbot-phone-calling-usa", name: "Phone Calling System — USA Standard Plug", price: 851.76, image: telephoneSystemImg, compatibleWith: "FlashBot Max" },
      { id: "flashbot-elevator-h9-usa", name: "Elevator Control System H9 — USA Standard", price: 1452.05, image: elevatorControlImg, compatibleWith: "FlashBot Max" },
      { id: "flashbot-elevator-h8-usa", name: "Elevator Control System H8 — USA Standard", price: 1452.05, image: elevatorControlImg, compatibleWith: "FlashBot Max" },
      { id: "flashbot-marker-camera", name: "Marker Camera Module", price: 306.23, image: placeholder, compatibleWith: "FlashBot Max" },
      { id: "flashbot-charging-ws3-usa", name: "Pudu Charging Pile WS3 — USA Standard", price: 1272.39, image: chargingStationImg, compatibleWith: "FlashBot Max" },
    ],
  },
  {
    category: "SH1",
    description: "Handheld and accessory kits for the PUDU SH1 floor scrubber.",
    products: [
      { id: "sh1-complete-handheld-kit", name: "Complete Handheld Accessory Kit", price: 306.23, image: placeholder, compatibleWith: "SH1" },
      { id: "sh1-window-surface", name: "Window & Surface Handheld Accessory", price: 119.65, image: placeholder, compatibleWith: "SH1" },
      { id: "sh1-floor-handheld", name: "Floor Handheld Accessory", price: 279.86, image: placeholder, compatibleWith: "SH1" },
      { id: "sh1-vacuum-handheld", name: "Vacuum Handheld Accessory", price: 214.97, image: placeholder, compatibleWith: "SH1" },
      { id: "sh1-mini-cleaning-combo", name: "Mini Cleaning Tool Combo", price: 24.34, image: placeholder, compatibleWith: "SH1" },
    ],
  },
  {
    category: "T300",
    description: "Accessories for the PUDU T300 industrial delivery robot.",
    products: [
      { id: "t300-lift-rack", name: "T300 Lift Rack", price: 582.04, image: liftingRackImg, compatibleWith: "T300" },
    ],
  },
  {
    category: "FlashBot / T300 / T600",
    description: "Shared accessories for FlashBot, T300, and T600 robots.",
    products: [
      { id: "cable-10floor-4long", name: "10-Floor Cable Pack — 4 Long Wire", price: 231.19, image: placeholder, compatibleWith: "FlashBot, T300, T600" },
      { id: "cable-10floor-2long", name: "10-Floor Cable Pack — 2 Long Wire", price: 176.44, image: placeholder, compatibleWith: "FlashBot, T300, T600" },
      { id: "cable-10floor-expansion-4long", name: "10-Floor Expansion Pack — 4 Long Wire", price: 324.48, image: placeholder, compatibleWith: "FlashBot, T300, T600" },
      { id: "elevator-h9k-korean", name: "Elevator Control System H9K — Korean Std", price: 1452.05, image: elevatorControlImg, compatibleWith: "FlashBot, T300, T600" },
    ],
  },
];

export const allAccessories = accessoryGroups.flatMap((g) =>
  g.products.map((p) => ({ ...p, category: g.category }))
);

export const findAccessoryById = (id: string) => allAccessories.find((a) => a.id === id);
